var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#03F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.358 36.46l-2.464-13.577a.46.46 0 00-.229-.32l-6.202-3.45a.458.458 0 00-.26-.055l1.129 14.556-.038.017 7.423 3.33a.462.462 0 00.641-.502zM24.683 22.41l-6.344-3.303a.459.459 0 00-.177-.05l-1.128 14.556 7.46 3.347a.46.46 0 00.189.04V22.41z",
    fill: "#44C868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.162 19.057a.46.46 0 00-.26.056l-6.202 3.45a.46.46 0 00-.228.32L9.007 36.457a.46.46 0 00.642.502l7.382-3.312 1.131-14.59zM31.203 19.058a.46.46 0 00-.177.05l-6.343 3.303v14.59a.459.459 0 00.188-.04l7.46-3.347-1.128-14.556z",
    fill: "#4CE166"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.725 26.996l-.5 2.758 7.411-3.915.172-2.22.029-.368-7.112 3.745z",
    fill: "#FFDB56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.703 24.979l-.067.86-7.412 3.915-1.217 6.704a.46.46 0 00.642.502l7.382-3.312.672-8.67z",
    fill: "#A8EEFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.684 24.23l-6.848-.979-.2 2.588 7.046 10.701v-3.891l-4.205-6.621 4.207.503v-2.3zM37.176 22.29l-2.98-1.656-2.82.659.035.455.14 1.797 5.625-1.254z",
    fill: "#FFBB24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.801 26.773l-.267-3.446-.157-2.034-6.692 2.938v2.3l4.37-1.9 2.746 2.142z",
    fill: "#FFDB56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.358 36.458l-.62-3.41-8.187-9.503.25 3.227 8.397 10.121a.46.46 0 00.16-.435z",
    fill: "#FFBB24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.712 9c-3.55 0-6.44 2.886-6.44 6.434 0 2.195 1.042 4.551 3.098 7.004a22.021 22.021 0 003.06 3.008.46.46 0 00.564 0 22.021 22.021 0 003.06-3.008c2.056-2.453 3.098-4.809 3.098-7.004 0-3.548-2.89-6.434-6.44-6.434zm2.385 6.434a2.384 2.384 0 01-2.385 2.383 2.384 2.384 0 112.385-2.383z",
    fill: "#FF4A4A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.712 9c-.282 0-.559.018-.83.053 3.16.409 5.608 3.115 5.608 6.381 0 2.195-1.041 4.551-3.097 7.004a23.042 23.042 0 01-2.512 2.552c.322.28.527.439.55.456a.46.46 0 00.563 0 22.021 22.021 0 003.06-3.008c2.056-2.453 3.098-4.809 3.098-7.004 0-3.548-2.89-6.434-6.44-6.434z",
    fill: "#E7343F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.871 36.96l2.774-1.245-2.962-3.066v4.352a.459.459 0 00.188-.04z",
    fill: "#FFDB56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.894 22.881a.46.46 0 00-.23-.32l-.487-.271-5.626 1.255 8.188 9.502-1.845-10.166zM24.683 37v-.46l-7.046-10.701-.603 7.773 7.46 3.347a.46.46 0 00.189.04z",
    fill: "#1EA4E9"
  })));
}
export default "/_next/static/media/integrations.1d8eb4ea8254e45587c8ee8e5fa28d47.svg";
export { SvgIntegrations as ReactComponent };